import {Avatar} from '@mantine/core';
import classes from './avatar.module.css';

export const AvatarTheme = Avatar.extend({
  classNames: {
    placeholder: classes.placeholder
  }
})